import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import * as React from 'react';
import ChartPackagesByCarrier from '../../components/ChartPackagesByCarrier';
import CustomizedTreeView from '../../components/CustomizedTreeView';
import HighlightedCard from '../../components/HighlightedCard';
import RealtimeStatus from '../../components/RealtimeStatus';
import StatCard from '../../components/StatCard';
import StatusFilterChips from '../../components/StatusFilterChips';
import Copyright from '../../internals/components/Copyright';
import TowersDataGrid from './TowersDataGrid';

export default function TowerGrid({
  rows,
  stats,
  isConnected,
  lastUpdate,
  connectionStatus,
  isRealTimeEnabled,
  selectedDate,
  currentUser,
  showCards,
  activeFilter,
  onFilterChange,
  // Status filter props
  selectedStatuses,
  statusCounts,
  onToggleStatus
}) {
  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      {/* cards - renderizar apenas se showCards for true */}
      {showCards && (
        <Grid
          container
          spacing={2}
          columns={12}
          sx={{ mt: 2, mb: (theme) => theme.spacing(2) }}
        >
          {stats.map((card, index) => (
            <Grid key={index} size={{ xs: 12, sm: 6, lg: 3 }}>
              <StatCard {...card} />
            </Grid>
          ))}
          <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
            <HighlightedCard />
          </Grid>
        </Grid>
      )}

      {/* Chips de filtro por status - logo acima da tabela */}
      <StatusFilterChips
        selectedStatuses={selectedStatuses}
        statusCounts={statusCounts}
        onToggleStatus={onToggleStatus}
      />

      <Grid container spacing={2} columns={12}>
        <Grid size={{ xs: 12, lg: showCards ? 9 : 12 }}>
          <TowersDataGrid
            rows={rows}
            selectedDate={selectedDate}
            currentUser={currentUser}
          />
        </Grid>
        {
          showCards && (
            <Grid size={{ xs: 12, lg: 3 }}>
              <Stack gap={2} direction={{ xs: 'column', sm: 'row', lg: 'column' }}>
                <RealtimeStatus
                  isConnected={isConnected}
                  lastUpdate={lastUpdate}
                  connectionStatus={connectionStatus}
                  isRealTimeEnabled={isRealTimeEnabled}
                />
                <CustomizedTreeView
                  trips={rows}
                  activeFilter={activeFilter}
                  onFilterChange={onFilterChange}
                />
                <ChartPackagesByCarrier trips={rows} />
              </Stack>
            </Grid>
          )
        }
      </Grid>
      <Copyright sx={{ my: 4 }} />
    </Box>
  );
}
